import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SvgImage } from 'components/SvgImage'
import {
  TERMS_LINKS_GROUP_VARIANT,
  TermsLinksGroup,
} from 'components/TermsLinksGroup'

import { useDelayedContinue } from 'hooks/useDelayedContinue'
import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import deskbookRemedyCardsImage from 'assets/images/deskbook-remedy-cards-image.webp'
import chevronRightIcon from 'assets/images/sprite/chevron-right.svg'

import { Language, OptionType } from 'root-constants'

import { StyledSelectFocusArea as S } from './SelectFocusArea.styles'
import { FOCUS_AREA_OPTIONS } from './constants'

export const SelectFocusArea: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
  isFirstPage,
}) => {
  const { t } = useTranslation()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const [answer, setAnswer] = useState<string>('')

  const handleContinue = useNextStep({
    pageId,
    question: t('onboarding.selectFocusArea.question', { lng: Language.EN }),
    nextPagePath,
    isFirstPage,
  })

  const handleAnswerChange = (value: string) => {
    handleChange(value, handleContinue)
    setIsAnswersDisabled(true)
    setAnswer(value)
  }

  return (
    <S.Container>
      <S.Hero>
        <S.HeroImage src={deskbookRemedyCardsImage} alt="" />
        <S.Badge>{t('onboarding.selectFocusArea.badge')}</S.Badge>
      </S.Hero>

      <S.Title>{t('onboarding.selectFocusArea.title')}</S.Title>
      <S.Question>{t('onboarding.selectFocusArea.question')}</S.Question>

      <S.Options>
        {FOCUS_AREA_OPTIONS.map(({ value, text }) => (
          <S.Option
            key={value}
            name={pageId}
            value={value}
            type={OptionType.RADIO}
            checked={answer === value}
            disabled={isAnswersDisabled}
            onChange={handleAnswerChange}
            withoutMargin
          >
            {t(text)}
            <SvgImage svg={chevronRightIcon} width={24} />
          </S.Option>
        ))}
      </S.Options>

      <S.Terms>
        <TermsLinksGroup
          titleKey="commonComponents.termsTitle"
          variant={TERMS_LINKS_GROUP_VARIANT.DARK}
        />

        <S.TermsNote>{t('commonComponents.termsNote')}</S.TermsNote>
      </S.Terms>
    </S.Container>
  )
}
